import { ControlButton, LanguageSelector, LocalizedText, Flex } from '@components';
import { User } from '@redux-modules/user/interfaces';
import { useBreakpoints } from '@utils/viewportUtils';
import React from 'react';
import { useLocale } from 'src/locales';
import UserMenu from './components/UserMenu';
import Styles from './styles';
import getConfig from 'next/config';

const publicRuntimeConfig = getConfig().publicRuntimeConfig;

const HeaderControls: React.FC<{ user: User }> = ({ user }) => {
  const { tabletAndDown } = useBreakpoints();
  const locale = useLocale();

  return (
    <Flex alignItems="center" gap="sm">
      <Flex alignItems="center" gap="default" fullHeight>
        {user?.businessOpportunityRole && !tabletAndDown && (
          <ControlButton
            href={`business-opportunities/dashboard`}
            leftIcon="cardMutedBlue"
            leftActiveIcon="cardWhite"
            activeOnHover
            activeColor="onBlack"
            fullHeight
            textProps={{
              color: 'mutedBlue100',
              letterSpacing: '0.4px'
            }}
            data-test-id="nav-bo-dashboard"
          >
            <LocalizedText id="globalNav.manageBO" />
          </ControlButton>
        )}
        <ControlButton
          leftIcon="switchMutedBlue"
          leftActiveIcon="switchWhite"
          activeOnHover
          activeColor="onBlack"
          textProps={{
            color: 'mutedBlue100',
            letterSpacing: '0.4px'
          }}
          href={`${publicRuntimeConfig.SGE_UNIFY_URL}/export/${locale}`}
          external
          fullHeight
        >
          <LocalizedText id="globalNav.backToHomepage" />
        </ControlButton>
        <ControlButton
          leftIcon="contactMutedBlue"
          leftActiveIcon="contactWhite"
          activeOnHover
          activeColor="onBlack"
          textProps={{
            color: 'mutedBlue100',
            letterSpacing: '0.4px'
          }}
          href="mailto:dpi@s-ge.com"
          external
          fullHeight
        >
          <LocalizedText id="globalNav.contact" />
        </ControlButton>
        <UserMenu user={user} />
      </Flex>
      <Styles.Delimiter />
      <LanguageSelector displayType="header" />
    </Flex>
  );
};

export default React.memo(HeaderControls);
